<h2 mat-dialog-title>{{'FORM.userForm.my_settings' | translate}}</h2>

<div mat-dialog-content>

  <p class="loading-row" *ngIf="loading">{{'loading' | translate}}...</p>

  <form [formGroup]="form" *ngIf="form" class="user-settings-form">

    <div class="section-header">{{'FORM.poiForm.h_general' | translate}}</div>

    <div class="field-row">
      <mat-form-field class="grow">
        <mat-label>{{'FORM.personForm.vorname' | translate}}</mat-label>
        <input matInput formControlName="firstName" required>
      </mat-form-field>

      <mat-form-field class="grow">
        <mat-label>{{'FORM.personForm.nachname' | translate}}</mat-label>
        <input matInput formControlName="lastName" required>
      </mat-form-field>
    </div>

    <div class="field-row">
      <mat-form-field class="grow">
        <mat-label>{{'FORM.personForm.geschlecht' | translate}}</mat-label>
        <mat-select formControlName="gender">
          <mat-option value="">— {{'none' | translate}} —</mat-option>
          <mat-option value="m">{{'FORM.personForm.genderMale' | translate}}</mat-option>
          <mat-option value="f">{{'FORM.personForm.genderFemale' | translate}}</mat-option>
          <mat-option value="d">{{'FORM.personForm.genderDiverse' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="grow">
        <mat-label>{{'FORM.userForm.salutation' | translate}}</mat-label>
        <input matInput formControlName="salutation">
      </mat-form-field>
    </div>

    <mat-form-field class="w-100">
      <mat-label>{{'FORM.userForm.title' | translate}}</mat-label>
      <input matInput formControlName="title">
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>{{'FORM.userForm.telephone' | translate}}</mat-label>
      <input matInput type="tel" formControlName="telephone">
    </mat-form-field>

    <div class="section-header">{{'FORM.userForm.legalAdress' | translate}}</div>

    <mat-form-field class="w-100">
      <mat-label>{{'FORM.userForm.address1' | translate}}</mat-label>
      <input matInput formControlName="address1">
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>{{'FORM.userForm.address2' | translate}}</mat-label>
      <input matInput formControlName="address2">
    </mat-form-field>

    <div class="field-row">
      <mat-form-field class="grow-narrow">
        <mat-label>{{'FORM.personForm.zip' | translate}}</mat-label>
        <input matInput formControlName="zip" maxlength="5">
      </mat-form-field>

      <mat-form-field class="grow">
        <mat-label>{{'FORM.personForm.city' | translate}}</mat-label>
        <input matInput formControlName="city">
      </mat-form-field>
    </div>

    <mat-form-field class="w-100">
      <mat-label>{{'FORM.personForm.country' | translate}}</mat-label>
      <mat-select formControlName="countryCode">
        <mat-option *ngFor="let co of allCountries" [value]="co.isoCode">{{ co.translate | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Only shown when the diwima-adis module is active for the current context. -->
    <ng-container *ngIf="showNotificationPreferences">
      <div class="section-header">{{'FORM.userForm.notification_preferences' | translate}}</div>
      <p class="hint">{{'FORM.userForm.notification_preferences_hint' | translate}}</p>

      <div class="notif-event-row" *ngFor="let event of notificationEvents">
        <span class="notif-event-label">{{ event.labelKey | translate }}</span>
        <mat-slide-toggle [formControlName]="mailControlName(event)">{{'FORM.userForm.channel_email' | translate}}</mat-slide-toggle>
        <mat-slide-toggle [formControlName]="pushControlName(event)">{{'FORM.userForm.channel_push' | translate}}</mat-slide-toggle>
      </div>
    </ng-container>

  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">{{'cancel' | translate}}</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="!form || form.invalid || saving"
    (click)="save()">
    {{'FORM.BTN_SAVE' | translate}}
  </button>
</div>
